import Layout from "@/components/Layout";
import HeroSection from "@/components/HeroSection";
import CalculatorBanner from "@/components/CalculatorBanner";
import BenefitsSection from "@/components/BenefitsSection";
import GallerySection from "@/components/GallerySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import StatsSection from "@/components/StatsSection";
import FAQSection from "@/components/FAQSection";
import InstagramSection from "@/components/InstagramSection";
import SeoContentSection from "@/components/SeoContentSection";
import FoilShowcase from "@/components/home/FoilShowcase";
import SpecTable from "@/components/home/SpecTable";
import OrderSteps from "@/components/home/OrderSteps";
import IndustriesGrid from "@/components/home/IndustriesGrid";
import { OrganizationJsonLd, LocalBusinessJsonLd } from "@/components/JsonLd";
import SEOHead from "@/components/SEOHead";
import ScrollReveal from "@/components/ScrollReveal";
import { useTranslation } from "react-i18next";

const Index = () => {
  const { t } = useTranslation();

  return (
    <Layout hideBreadcrumbs>
      <SEOHead
        title={t("seo.homeTitle")}
        description={t("seo.homeDescription")}
      />
      <OrganizationJsonLd />
      <LocalBusinessJsonLd />
      <HeroSection />
      <CalculatorBanner />
      <ScrollReveal delay={0.1}>
        <BenefitsSection />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <FoilShowcase />
      </ScrollReveal>
      <ScrollReveal>
        <GallerySection />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <SeoContentSection />
      </ScrollReveal>
      <ScrollReveal>
        <OrderSteps />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <IndustriesGrid />
      </ScrollReveal>
      <ScrollReveal>
        <SpecTable />
      </ScrollReveal>
      <ScrollReveal>
        <StatsSection />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <InstagramSection />
      </ScrollReveal>
      <ScrollReveal>
        <TestimonialsSection />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <FAQSection />
      </ScrollReveal>
    </Layout>
  );
};

export default Index;
